import { combineReducers } from "redux";
import { reducer as formReducer } from "redux-form";
import SecondaryBillingReducer from "./reducer";
const SecondaryBilling = combineReducers({
  SecondaryBilling: SecondaryBillingReducer,
  form: formReducer,
});

export default SecondaryBilling;
